<script>
import moment from "moment";
import {deleteSubscriber, getS3Subscribers, deletedCustomer} from "@/api/subscribers";
import AddSubscriberDialog from "@/view/components/subscribers/AddSubscriberDialog.vue";
import UploadSubscribersModal from "@/view/components/subscribers/UploadSubscribersModal.vue";
import {money_format} from "@/utils";
import DataTableSection from "@/view/components/helper/datatable/datatableServerSide.vue";
import DataTableSingle from "@/view/components/helper/datatable/datatableSingleFetchS3.vue";
import papa from "papaparse";

export default {
  components: {
    AddSubscriberDialog,
    UploadSubscribersModal,
    DataTableSection,
    DataTableSingle
  },
  props: ["dspfunc"],
  data() {
    return {
      showSelect: true,
      hide: false,
      loading1: false,
      s3items: [],
      copyOfS3items: [],
      nextItem:1,
      companyName: '',
      usingBigData: false,
      useDatatableCSV: false,
      dataTableReady: false,
      search: "",
      selected: [],
      dialogDelete: false,
      dialogMsg: "Are you sure you want to delete this selected items?",
      error: false,
      editedIndex: -1,
      items: [],
      item: [],
      snackbar: false,
      text: "Loading subscribers...",
      timeout: 2000,
      loading: true,
      startSearchKeyLength: 3,
      upload: false,
      add: false,
      tableDataParam: {
        getters: 'getSubscribers',
        settersItem: 'setSubScriberItem',
        settersPage: 'setSubscriberPage',
        gettersPage: 'getSubscriberPage',
        // dispatchFunction: 'getLocationSubscribersPaginated',
        dispatchFunction:this.dspfunc,
        headers: [
          {
            text: "Name",
            align: "start",
            sortable: false,
            value: "name"
          },
          {text: "Email", value: "email", sortable: false},
          {text: "Email Sent", value: "email_sent", sortable: false},
          {text: "Revenue", value: "revenue", sortable: false},
          {text: "Opens", value: "opens", sortable: false},
          {text: "Clicks", value: "clicks", sortable: false},
          {text: "Subscribed", value: "created", sortable: false}
        ]        
      },
      customRenderers: [
        {
          field: "name",
        },{
          field: "subscriber_lists",
        },{
          field: "created",
        }
      ],
      tableDataParamCFG: {
        getters: 'getSubscribers',
        dispatchFunction: 'getSubscriberS3',
        setQuery: 'setSubscriberPageS3',
        getQuery: 'getSubscriberPageS3',
        queryValue: { pageFile:1, totalRowsCount: 100, fileEndCount:100},
        headers: [
          {
            text: "Name",
            align: "left",
            sortable: false,
            value: "customer_name"
          },
          {text: "Email", value: "email", sortable: false},
          {text: "First Transaction", value: "min_time", sortable: false}
        ]
      },
      CfgCustomRenderers: [
        {
          field: "customer_name",
        }
      ],
    };
  },
  computed: {
    searchTrigger() {
      return this.search;
    },
  },
  async mounted() {
    let accountSetting = await this.$store.getters["getAccountSettings"];
    console.log("Account Settings:",accountSetting);
    this.usingBigdata = accountSetting.company_details.company.using_bigdata
    if (this.usingBigdata) {
      this.useDatatableCSV = true
      this.hide = true
    }
    this.dataTableReady = true
  },
  watch: {
    searchTrigger(q) {
      if (q.length >= this.startSearchKeyLength || q == "") {
        if(!this.useDatatableCSV){
          let componentEvent = this.$refs.dataTableComponent
          componentEvent.requestAjaxTableData(q)
        }else{
          let componentEvent2 = this.$refs.dataTableComponentSecond
          componentEvent2.updateSearchField(q)
        }
      }
    }
  },
  methods: {
    async downloadCsv(url = ''){
      return new Promise((resolve, reject) => {
        papa.parse(url, {
          download: true,
          dynamicTyping: true,
          header: true,
          complete: function(results) {
            resolve(results)
          }
        });
      })
    },
    async loadMore () {
      this.loading1 = true;
      let result = []
      let locationIds = this.$store.getters['getLocationIds'];
      try {
        console.log('---papaparse v2', this.useDatatableCSV)
        const response = await getS3Subscribers(
          locationIds,
          true,
          this.nextItem
        );
        result = await Promise.all(response['urls'].map(data => this.downloadCsv(data)))
        result = result.map(res => res.data).flat()

      } catch (error) {
        console.log('---error3: ', result)
      }

      //this parse the new result to old result and add pager by 1
      this.s3items.push(result);
      this.s3items = this.s3items.flat()
      this.copyOfS3items = this.s3items.flat()
      this.nextItem++
      this.loading1 = false;
    },
    moneyFormat(value) {
      return money_format(value);
    },
    dateFormat(value) {
      return moment(value).format("lll");
    },
    showAddDialog() {
      this.add = false;
      this.add = true;
      this.$store.commit("showAddDialog");
    },
    exportItems() {
      if (this.selected.length === 0) {
        alert("Please select at least one subscriber");
      } else {
        let items = [];
        for (let i = 0; i < this.selected.length; i++) {
          let item = this.selected[i];

          if (!this.useDatatableCSV ){ // export from api datatable
            let subscriber_lists = [];
            for (let x = 0; x < item.subscriber_lists.length; x++) {
              let subscriber_list = item.subscriber_lists[x];
              subscriber_lists.push(subscriber_list.name);
            }
            items.push({
              id: item.id,
              name: item.name,
              email: item.email,
              subscriber_lists: subscriber_lists.toString(),
              revenue: item.revenue,
              email_sent: item.email_sent,
              opens: item.opens,
              clicks: item.clicks,
              subscribed: item.subscribed
            });
          }else{ // export from S3 CSV datatable
            items.push({
              name: item.customer_name,
              email: item.email,
              revenue: item.lifetime_value,
              'transaction date': item.min_time
            });
          }
        }

        let csv = this.$papa.unparse(items);
        this.$papa.download(
            csv,
            `AllSubscribers-${moment().format("YYYY-MM-DD-HH-mm")}`
        );
      }
    },
    removeItems() {
      if (this.selected.length === 0) {
        this.error = true;
        this.dialogMsg = "Please select at least one item";
      } else {
        this.dialogMsg = "Are you sure you want to delete this selected items?";
        this.error = false;
      }
      this.dialogDelete = true;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    async removeItemsConfirm() {
      this.dialogDelete = false;
      for (let i = 0; i < this.selected.length; i++) {
        let item = this.selected[i];        
        let pk = item.customer_name + '_' + item.last_four_digits.toString().padStart(4, '0')
        let pos_id = item.pos_id
        let hash_id =  item.id
        try {
          let response = await deletedCustomer(pk, hash_id, pos_id);
          if ('success' in response){
            if(response['success']){
              this.$bvToast.toast(`Deleted ${item.customer_name}`, {
              title: "Subscriber",
              autoHideDelay: 3000,
              appendToast: false,
              variant: "info"
              });
            }          
          }        
        } catch (error) {
          console.log("error:",error)        
        }
        
      }
      this.selected = [];
      // setTimeout(() => {
      //   this.$store.dispatch("getLocationSubscribersPaginated");
      // }, 3000);
      let componentEvent = this.$refs.dataTableComponent
      componentEvent.requestAjaxTableData()
      this.$router.push({ path: '/subscribers' })
    },
    showUpdateSubscriberModal(item) {
      localStorage.setItem("guest", "subscriber");
      this.$router.push(`/subscriber/profile/${item.pos_id}/${item.id}/${item.pk_id}`);
    },
    syncSelectedItem(selectedCollection) {
      this.selected = selectedCollection
    }
  }
};
</script>

<template>
  <v-card flat>
    <v-row class="mb-5">
      <v-col cols="12" md="8">
        <v-btn v-if="!hide" class="mr-4" depressed tile @click="removeItems()">
          <v-icon left> mdi-delete</v-icon>
          Remove
        </v-btn>
        <v-btn class="mr-4" depressed tile @click="exportItems()">
          <v-icon left> mdi-file-export</v-icon>
          Export
        </v-btn>
        <v-btn class="mr-4" depressed tile @click="removeItems()">
          <v-icon left> mdi-delete </v-icon>
          Delete
        </v-btn>
        <!-- <v-btn TEMPORARY disabled
            class="mr-4"
            depressed
            tile
            @click="upload = true"
            v-b-modal.modal-upload-subscribers
        >
          <v-icon left> mdi-cloud-upload</v-icon>
          Upload
        </v-btn> -->
        <v-btn v-if="!hide" class="mr-4" depressed tile @click="showAddDialog">
          <v-icon left> mdi-plus-box</v-icon>
          Add
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <b-icon icon="search"></b-icon>
            </div>
          </div>
          <b-form-input v-model="search" placeholder="Search subscriber name"></b-form-input>
        </div>
      </v-col>
    </v-row>
      <!-- <div v-if="useDatatableCSV" class="list-group-wrapper cfg-table">
        <transition name="fade">
          <div class="loading-inf" v-show="loading1">
            <span class="fa fa-spinner fa-spin"></span> Loading
          </div>
        </transition>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" >
                  Name
                </th>
                <th class="text-left" >
                  Email
                </th>
                <th class="text-left" >
                  Revenue
                </th>
                <th class="text-left" >
                  First Transactiom
                </th>
              </tr>
            </thead>
            <tbody id="infinite-list" >
              <tr
                v-for="item in s3items"
                :key="item.customer_name"
              >
                <td >{{ item.customer_name }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.lifetime_value }}</td>
                <td>{{ item.min_time }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div> -->

    <data-table-single
      class="csv-datatable-customize"
      v-if="useDatatableCSV && dataTableReady"
      :tableData="this.tableDataParamCFG"
      :customRenderers="this.CfgCustomRenderers"
      :isSelectEnabled="true"
      :selectKey="'customer_name'"
      :isSearch="this.loading"
      ref="dataTableComponentSecond"
      @datatableSelectedItem="syncSelectedItem"
      >
      <!-- :setPerPage="50" -->
      <template v-slot:customer_nameparams="{ item }">
        <v-btn text color="primary"
          @click="showUpdateSubscriberModal({ pk_id: item.customer_name + '_' + item.last_four_digits.toString().padStart(4, '0'),  ...item})"
          >
          {{ item.customer_name ? item.customer_name : "No Name" }}
        </v-btn>
      </template>
    </data-table-single>

    <data-table-section
      class="server-datatable-customize"
      v-if="!useDatatableCSV && dataTableReady"
        :tableData="this.tableDataParam"
        :customRenderers="this.customRenderers"
        :searchField="this.search"
        @datatableSelectedItem="syncSelectedItem"
        ref="dataTableComponent"
    >
      <template v-slot:nameparams="{ item }">
        <v-btn text color="primary" @click="showUpdateSubscriberModal(item)">
          {{ item.name }}
        </v-btn>
      </template>
      <template v-slot:subscriber_listsparams="{ item }">
        <div v-for="(item, index) in item.subscriber_lists" :key="index">
          {{ item.name }}
        </div>
      </template>
      <template v-slot:revenueparams="{ item }">
        {{ moneyFormat(item.revenue) }}
      </template>
      <template v-slot:createdparams="{ item }">
        {{ dateFormat(item.created) }}
      </template>
    </data-table-section>



    <v-dialog v-model="dialogDelete" max-width="510px">
      <v-card>
        <v-card-title class="headline">{{ dialogMsg }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!error" color="blue darken-1" text @click="closeDelete"
          >Cancel
          </v-btn
          >
          <v-btn
              v-if="!error"
              color="blue darken-1"
              text
              @click="removeItemsConfirm"
          >OK
          </v-btn
          >

          <v-btn v-if="error" color="blue darken-1" text @click="closeDelete"
          >Close
          </v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <add-subscriber-dialog v-if="add"></add-subscriber-dialog>
    <!-- <update-subscriber-dialog></update-subscriber-dialog> -->
    <upload-subscribers-modal v-if="upload"></upload-subscribers-modal>
    <!-- <update-subscriber-modal :item="item"></update-subscriber-modal> -->
  </v-card>
</template>


<style >

.cfg-table tbody {
    display: block;
    height: 400px;
    overflow: auto;
}
.cfg-table thead, 
.cfg-table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}
.loading-inf {
  text-align: center;
  position: absolute;
  color: #fff;
  z-index: 9;
  background: #5867dda3;
  padding: 8px 18px;
  border-radius: 5px;
  left: calc(50% - 45px);
  top: calc(33% - 18px);
}
</style>